import { css } from "emotion";

const SeparatorDiv = ({}) => {
  return (
    <div
      className={css({
        width: "100%",
        height: 24,
        backgroundColor: "#f9f9fa"
      })}
    />
  );
};

export default SeparatorDiv;
